module.exports = __webpack_public_path__ + "static/img/home-3.19654c37.jpg";